import { useCallback, Fragment } from 'react';
import { Polyline, Popup, Circle } from 'react-leaflet';

import {
  useAppSelector,
  useAppDispatch,
  spacePositionsSelector,
  activeImageSelector,
  formatRouteDuration,
  formatRouteDistance,
  currentRouteSelector,
  routeSummarySelector,
  routeCoordinatesSelector,
  setCurrentRoute,
  selectedWaypointIdsSelector,
} from '../../../store';

export function RouteDisplay() {
  const dispatch = useAppDispatch();
  const route = useAppSelector(currentRouteSelector);
  const routeSummary = useAppSelector(routeSummarySelector);
  const coordinates = useAppSelector(routeCoordinatesSelector);
  const selectedWaypointIds = useAppSelector(selectedWaypointIdsSelector);
  const spacePositions = useAppSelector(spacePositionsSelector);
  const activeImage = useAppSelector(activeImageSelector);

  const handleClearRoute = useCallback(() => {
    dispatch(setCurrentRoute(null));
  }, [dispatch]);

  const selectedWaypointCircles = selectedWaypointIds
    .filter((id) => id !== 'current' && spacePositions[id] && spacePositions[id].layerId === activeImage?.id)
    .map((id) => (
      <Circle
        key={`waypoint-circle-${id}`}
        center={[spacePositions[id].x, spacePositions[id].y]}
        radius={8}
        pathOptions={{
          fillColor: '#007AFF',
          fillOpacity: 0.4,
          color: '#007AFF',
          weight: 2,
        }}
      />
    ));

  if (!coordinates || !route?.routes?.[0]) {
    return selectedWaypointCircles.length > 0 ? <>{selectedWaypointCircles}</> : null;
  }

  return (
    <>
      {selectedWaypointCircles}
      <Polyline
        positions={coordinates as [number, number][]}
        pathOptions={{
          color: '#007AFF',
          weight: 4,
          opacity: 0.8,
          lineCap: 'round',
          lineJoin: 'round'
        }}
      >
        <Popup>
          <article className="route-popup">
            <h2 aria-hidden="true">Route Information</h2>
            {routeSummary && (
              <dl className="route-info">
                <div className="route-stat">
                  <dt>Distance:</dt>
                  <dd>{formatRouteDistance(routeSummary.distance)}</dd>
                </div>
                <div className="route-stat">
                  <dt>Duration:</dt>
                  <dd>{formatRouteDuration(routeSummary.duration)}</dd>
                </div>
                <div className="route-stat">
                  <dt>Waypoints:</dt>
                  <dd>{routeSummary.waypoints}</dd>
                </div>
              </dl>
            )}
            <button
              className="clear-route-btn"
              onClick={handleClearRoute}
              aria-label="Clear current route"
              style={{
                marginTop: '0.5em',
                padding: '0.25em 0.5em',
                background: '#ff4444',
                color: 'white',
                border: 'none',
                borderRadius: '0.25em',
                cursor: 'pointer',
                fontSize: '0.75em'
              }}
            >
              Clear Route
            </button>
          </article>
        </Popup>
      </Polyline>
    </>
  );
}
